"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("@icr-ui/theme");
const react_1 = require("react");
const icons_1 = require("@icr-ui/icons");
const styles_1 = require("./styles");
const flexbox_1 = require("../flexbox");
const hooks_1 = require("@icr-ui/hooks");
const Stepbar = (0, react_1.forwardRef)((props, ref) => {
    const isSmallScreen = (0, hooks_1.useMediaQuery)('(max-width: 768px)');
    const { steps, currentStep, currentSubStep, onStepChange, onSubStepChange, isVertical = false, isMinimizedLabel, stepsCompleted, subStepsCompleted, isIncompleteDisabled = false, ...rest } = props;
    const stepItems = steps.map(({ label, number, subStep }) => {
        const isStepCurrent = number === currentStep;
        const isStepCompleted = stepsCompleted
            ? stepsCompleted === null || stepsCompleted === void 0 ? void 0 : stepsCompleted.includes(number)
            : number < currentStep;
        const isBeforeCurrentStep = number <= currentStep;
        const [isOpen, setIsOpen] = (0, react_1.useState)(false);
        const handleStepChange = () => {
            !!onStepChange && isIncompleteDisabled
                ? isBeforeCurrentStep && onStepChange(number)
                : onStepChange(number);
            if (isVertical) {
                if (isIncompleteDisabled) {
                    isBeforeCurrentStep && setIsOpen(!isOpen);
                }
                else
                    setIsOpen(!isOpen);
            }
            if (isVertical && number <= currentStep)
                setIsOpen(!isOpen);
        };
        if (!isVertical && isMinimizedLabel) {
            const lastItem = steps[steps.length - 1];
            if (lastItem.number !== number)
                label = '.....';
            else
                label = '';
        }
        (0, react_1.useEffect)(() => {
            isStepCurrent && !isOpen && setIsOpen(true);
            !isStepCurrent && isOpen && setIsOpen(!isOpen);
        }, [isStepCurrent]);
        const iconSize = isSmallScreen ? '12px' : '16px';
        return ((0, jsx_runtime_1.jsxs)(styles_1.StyledStepbarItemWrapper, { noPadding: true, ...{ isVertical, ...rest }, "data-testid": "stepbar-item", children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledStepbarItem, { alignItems: "center", justifyContent: "space-between", ...{
                        isStepCurrent,
                        isStepCompleted,
                        isVertical,
                        isOpen,
                        isMinimizedLabel,
                        isBeforeCurrentStep,
                        isIncompleteDisabled,
                    }, onClick: handleStepChange, flexDirection: "row", fullWidth: true, "data-testid": `stepbar-item-${number}`, children: [(0, jsx_runtime_1.jsxs)(flexbox_1.Flexbox, { flexDirection: "row", gap: isVertical ? '16px' : isSmallScreen ? '4px' : '8px', noWrap: true, children: [(0, jsx_runtime_1.jsx)(styles_1.StyledStepbarCheckIcon, { alignItems: "center", justifyContent: "center", "data-testid": "checkmark-icon", ...{ isStepCurrent, isStepCompleted }, children: isStepCompleted ? ((0, jsx_runtime_1.jsx)(icons_1.CheckmarkIcon, { color: theme_1.palette.grayScale[50], width: iconSize, height: iconSize })) : (number) }), (0, jsx_runtime_1.jsx)(styles_1.StyledStepbarDescription, { variant: 'heading', size: "h4", children: label })] }), isVertical && subStep && ((0, jsx_runtime_1.jsx)(styles_1.StyledStepbarChevronIcon, { alignItems: "center", justifyContent: "center", ...{ isStepCurrent, isStepCompleted, isOpen }, children: (0, jsx_runtime_1.jsx)(icons_1.ChevronDownIcon, { color: theme_1.palette.grayScale[600] }) }))] }), isVertical &&
                    subStep &&
                    (subStep === null || subStep === void 0 ? void 0 : subStep.map(({ label, number }) => {
                        const isSubStepCurrent = number === currentSubStep;
                        const isSubStepCompleted = subStepsCompleted
                            ? subStepsCompleted === null || subStepsCompleted === void 0 ? void 0 : subStepsCompleted.includes(number)
                            : number < currentSubStep;
                        const isBeforeCurrentSubStep = number <= currentStep;
                        const handleSubStepChange = () => {
                            !!onSubStepChange && number <= currentSubStep && onSubStepChange(number);
                            !!onSubStepChange && isIncompleteDisabled
                                ? number <= currentSubStep && onSubStepChange(number)
                                : onSubStepChange(number);
                        };
                        return ((0, jsx_runtime_1.jsx)(styles_1.StyledStepbarSubItem, { "data-testid": `stepbar-sub-item`, fullWidth: true, alignItems: "flex-start", onClick: handleSubStepChange, gap: "12px", ...{
                                isOpen,
                                isSubStepCurrent,
                                isSubStepCompleted,
                                isStepCompleted,
                                isStepCurrent,
                                isBeforeCurrentSubStep,
                                isIncompleteDisabled,
                            }, children: (0, jsx_runtime_1.jsx)(styles_1.StyledSubItemDescription, { variant: "body", size: "small", weight: "medium", colorScheme: { type: 'text', color: 'disabled' }, children: label }) }, number));
                    }))] }, number));
    });
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledStepbar, { fullWidth: true, alignItems: "center", "data-testid": "stepbar-wrapper", ...{ isVertical, isMinimizedLabel }, ref: ref, children: stepItems }));
});
Stepbar.displayName = 'Stepbar';
exports.default = Stepbar;
//# sourceMappingURL=stepbar.js.map